<template>
  <v-content>
    <Nav/>

    <postview
      :uid="$route.params.post"
    />

    <Footer/>
  </v-content>
</template>

<style lang="scss">
.post {
    h1 {
        margin-top: 20px;
        background-color: rgba(187,187,187,0.20);
        border-radius: 4px;
        padding-left: 10px;
        font-weight: 500;
        font-family: Oswald,Haas Grot Text R Web,Helvetica Neue,Helvetica,Arial,sans-serif;
    }
    h2 {
        margin-top: 20px;
        border-bottom: 1px solid #e9640a;
        width: 80%;
        font-weight: 500;
    }
    h3 {
        margin-top: 20px;
        font-weight: 600;
    }
    p {
        margin-top: 20px;
        line-height: 1.6;
    }
    ul {
        margin-top: 10px;
        padding-left: 40px;
        li {
            margin-bottom: 10px;
        }
    }
    pre { // this is for code blocks
        background-color: rgba(0,0,0,.05);
        padding: 15px 10px;
        margin: 20px 20px 0px 20px;
        overflow-x: scroll;
        line-height: 1.8;
        border: 1px solid #f2f3f3;
        border-radius: 4px;
        background-color: #fafafa;
        box-shadow: 0 1px 1px rgba(0,0,0,0.125);

        code {
            white-space: pre;
            font-weight: 400;
            // font-family: Monaco,Consolas,"Lucida Console",monospace;
        }
    }
    p img, li img, img {
        display: block;
        max-width: 100%;
        height: auto;
        box-shadow: 1px 2px 2px 1px #bbb;
        margin-top: 10px;
    }

    .notice-warning {
        margin: 2em 0;
        padding: 1em;
        // font-family: -apple-system,".SFNSText-Regular","San Francisco","Roboto","Segoe UI","Helvetica Neue","Lucida Grande",Arial,sans-serif;
        // font-size: .75em !important;
        text-indent: initial;
        background-color: #fef4e6;
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(248,148,6,0.25);
    }
    .notice-info {
        margin: 2em 0;
        padding: 1em;
        // font-family: -apple-system,".SFNSText-Regular","San Francisco","Roboto","Segoe UI","Helvetica Neue","Lucida Grande",Arial,sans-serif;
        // font-size: .75em !important;
        text-indent: initial;
        background-color: #eef7fa;
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(82,173,200,0.25);
    }
}
</style>


<script>
import Nav from '../components/global/Nav';
import Footer from '../components/global/Footer';
import postview from '../components/postview';



export default {
  name: 'post',

  components: {
    Nav,
    Footer,
    postview,
  },

  props: {

  },

  data() {
    return {
      
    }
  },

  created: function() {

  },

  methods: {


  }
};
</script>